module.exports = __webpack_public_path__ + "img/banner1.47bf37f0.png";